import React from 'react';
import { FaFacebookSquare, FaTwitter, FaInstagram } from 'react-icons/fa';

import FooterImg from '../../images/footer-logo.png';

const AuthFooter = () => {
  return (
    <div className="container-inner mx-auto my-10 text-xs">
      <div className="flex flex-wrap">
        <div className="w-1/4 md:w-1/6">
          <h6>Company</h6>
          <ul className="mt-2">
            <li>
              <a href="https://www.completefarmer.com/about">About us</a>
            </li>
            <li>
              <a href="https://www.completefarmer.com/about#team">Team</a>
            </li>
            <li>
              <a href="https://www.completefarmer.com/contact">Contact us</a>
            </li>
            <li>
              <a href="https://www.completefarmer.com/careers">Careers</a>
            </li>
            <li>
              <a href="https://www.completefarmer.com/news">Press</a>
            </li>
          </ul>
        </div>
        <div className="w-1/4 md:w-1/6">
          <h6>Our Products</h6>
          <ul className="mt-2">
            <li>
              <a href="https://www.completefarmer.com/crowdfarmer">For Crowdfarmer</a>
            </li>
            <li>
              <a href="https://www.completefarmer.com/buyers">For Buyers</a>
            </li>
            <li>
              <a href="https://www.completefarmer.com/marketplace">Marketplace</a>
            </li>
            <li>
              <a href="https://www.completefarmer.com/farms">Our Farms</a>
            </li>
          </ul>
        </div>
        <div className="w-1/4 md:w-1/6">
          <h6>Resources</h6>
          <ul className="mt-2">
            <li>
              <a href="https://www.completefarmer.com">Product Support</a>
            </li>
            <li>
              <a href="https://www.completefarmer.com/blog">Blog</a>
            </li>
            <li>
              <a href="https://www.completefarmer.com">Customer Stories</a>
            </li>
          </ul>
        </div>
        <div className="w-1/4 md:w-1/6">
          <h6>Legal</h6>
          <ul className="mt-2">
            <li>
              <a href="https://www.completefarmer.com/terms-and-conditions">
                Terms &amp; Conditions
              </a>
            </li>
            <li>
              <a href="https://www.completefarmer.com/privacy-policy">Privacy Policies</a>
            </li>
            <li>
              <a href="https://www.completefarmer.com/terms">Cookies</a>
            </li>
          </ul>
        </div>
        <div className="w-full md:w-2/6 mt-4 md:mt-0">
          <h6>Follow us on social media</h6>
          <ul className="flex flex-wrap items-center text-xl mt-2">
            <li className="pr-4">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/CompleteFarmer/"
              >
                <FaFacebookSquare />
              </a>
            </li>
            <li className="pr-4">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://twitter.com/completefarmer"
              >
                <FaTwitter />
              </a>
            </li>
            <li className="pr-4">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.instagram.com/completefarmer/"
              >
                <FaInstagram />
              </a>
            </li>
          </ul>
        </div>
        <div className="flex flex-wrap items-center mt-8 border-t border-gray-400 py-6">
          <div className="flex items-center">
            <div className=" mr-2">
              <a href="https://www.completefarmer.com">
                <img className="h-10" src={FooterImg} alt="Complete Farmer Logo" />
              </a>
            </div>
            <p className="text-xs sm:text-base">
              <span className="text-gray-900 font-bold">Complete</span>{' '}
              <span className="text-cf-300 ">Farmer</span> Limited, {new Date().getFullYear()}. All
              rights reserved.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthFooter;
